<template>
    <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
            <Form @submit="EditValidationCheck">
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group mb-15 mb-sm-20 mb-md-25">
                            <label class="d-block text-black fw-semibold mb-10">
                                Titre <span class="text-danger">*</span>
                            </label>
                            <Field name="title" type="text" class="form-control shadow-none fs-md-15 text-black"
                                placeholder="Entrez le titre " v-model="formData.title" />
                            <ErrorMessage name="title" class="text-danger" />
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group mb-15 mb-sm-20 mb-md-25">
                            <label class="d-block text-black fw-semibold mb-10">
                                Code technique unique du contrôle <span class="text-danger">*</span>
                            </label>
                            <Field name="check_code" type="text" class="form-control shadow-none fs-md-15 text-black"
                                placeholder="" v-model="formData.check_code" />
                            <ErrorMessage name="check_code" class="text-danger" />
                        </div>
                    </div>

                    <div class="col-md-12">
                        <div class="form-group mb-15 mb-sm-20 mb-md-25">
                            <label class="d-block text-black fw-semibold mb-10">
                                Description <span class="text-danger">*</span>
                            </label>
                            <Field name="description" as="textarea" class="form-control shadow-none fs-md-15 text-black"
                                v-model="formData.description" />
                            <ErrorMessage name="description" class="text-danger" />
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group mb-15 mb-sm-20 mb-md-25">
                            <label class="d-block text-black fw-semibold mb-10">
                                Type de contrôle <span class="text-danger">*</span>
                            </label>
                            <Multiselect :options="checkTypeOptions" :searchable="true" multiple="false"
                                value-prop="value" track-by="value" :object="true" label="label"
                                v-model="formData.check_type" placeholder="Selectionnez le type de controle" />
                            <ErrorMessage name="check_type" class="text-danger" />
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group mb-15 mb-sm-20 mb-md-25">
                            <label class="d-block text-black fw-semibold mb-10">
                                Résultat du contrôle <span class="text-danger">*</span>
                            </label>

                            <Multiselect :options="resultOptions" :searchable="true" multiple="false" value-prop="value"
                                track-by="value" :object="true" label="label" v-model="formData.result"
                                placeholder="Sélectionner le resultat du controle" />

                            <ErrorMessage name="result" class="text-danger" />
                        </div>
                    </div>

                    <div class="col-md-6">
                        <div class="form-group mb-15 mb-sm-20 mb-md-25">
                            <label class="d-block text-black fw-semibold mb-10">
                                Niveau de sévérité du contrôle en cas d’échec <span class="text-danger">*</span>
                            </label>

                            <Multiselect :options="severityOptions" :searchable="true" multiple="false"
                                value-prop="value" track-by="value" :object="true" label="label"
                                v-model="formData.severity" placeholder="Sélectionner le niveau de sévérité" />
                            <ErrorMessage name="severity" class="text-danger" />
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group mb-15 mb-sm-20 mb-md-25">
                            <label class="d-block text-black fw-semibold mb-10">
                                Date et heure ou le contrôle a été mis à jour. <span class="text-danger">*</span>
                            </label>
                            <Field name="checked_at" type="date" class="form-control shadow-none fs-md-15 text-black"
                                v-model="formData.checked_at" />
                            <ErrorMessage name="checked_at" class="text-danger" />
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="form-group mb-15 mb-sm-20 mb-md-25">
                            <label class="d-block text-black fw-semibold mb-10">
                                Commentaire<span class="text-danger">*</span>
                            </label>
                            <Field name="comments" as="textarea" type="text"
                                class="form-control shadow-none fs-md-15 text-black" placeholder="Entrez le commentaire"
                                v-model="formData.comments" />
                            <ErrorMessage name="comments" class="text-danger" />
                        </div>
                    </div>

                    <div class="col-md-6">
                        <div class="form-group mb-15 mb-sm-20 mb-md-25">
                            <label class="d-block text-black fw-semibold mb-10">
                                Validation Tasks <span class="text-danger">*</span>
                            </label>
                            <Multiselect :options="validationtaskOptions" :searchable="true" multiple="false"
                                value-prop="value" track-by="label" label="label" :object="true"
                                v-model="formData.validationtasks" placeholder="Sélectionner la validation Tasks" />

                            <ErrorMessage name="validationtasks" class="text-danger" />
                        </div>
                    </div>

                    <div class="col-md-12">
                        <div class="d-flex align-items-center ">
                            <button
                                class="default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success"
                                type="submit">
                                Modifier
                            </button>
                            <router-link to="/listevalidationchecks"
                                class=" btn btn-danger transition border-0 lh-1 fw-medium"><i
                                    class="flaticon-delete lh-1 me-1 position-relative top-2"></i>
                                <span class="position-relative"></span>Annuler</router-link>
                        </div>
                    </div>

                </div>
            </Form>
        </div>
    </div>
</template>


<script lang="ts">
import { defineComponent, onMounted, reactive, ref, watch, nextTick } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import ApiService from '../../services/ApiService';
import * as Yup from 'yup';
import { error, success, hideModal } from '../../utils/utils';
import { TypeFretPaiement } from '@/models/TypeFretPaiement';
import { Modal } from 'bootstrap';
import Multiselect from '@vueform/multiselect'
import { ValidationQueues } from '@/models/ValidationTask';
import { ValidationComment } from '@/models/ValidationComment';
import { ValidationCheck } from '@/models/ValidationCheck';
import JwtService from '@/services/JwtService';
import router from '@/router';
import { useRoute, useRouter } from 'vue-router';

export default defineComponent({
    name: "EditValidationCheck",
    components: {
        Form,
        Field,
        ErrorMessage,
        Multiselect

    },
    props: {
        item: {
            type: Number,
            default: 0,
        }
    },
    setup(props, { emit }) {
        const EditCheckSchema = Yup.object().shape({
            // title: Yup.string().required('Ce champ est obligatoire'),
            // check_code: Yup.string().required('Ce champ est obligatoire'),
            // validationtasks: Yup.object().required('Ce champ est obligatoire'),
            // description: Yup.string().required('Ce champ est obligatoire'),
            // check_type: Yup.object().required('Ce champ est obligatoire'),
            // result: Yup.object().required('Ce champ est obligatoire'),
            // severity: Yup.object().required('Ce champ est obligatoire'),
            // comments: Yup.string().required('Ce champ est obligatoire'),
            // checked_at: Yup.string().required('Ce champ est obligatoire'),

        });

        interface Option {
            value: number | string;
            label: string;
        }
        const validationtaskOptions = ref<Option[]>([]);
        const router = useRouter();
        const route = useRoute();
        const checkId = route.params.id;

        const severityOptions = [
            { value: 'Info', label: 'Info' },
            { value: 'Warning', label: 'Warning' },
            { value: 'Blocking', label: 'Blocking' }

        ]
        const resultOptions = [
            { value: 'En Attente', label: 'En Attente' },
            { value: 'Validé', label: 'Validé' },
            { value: 'Echoué', label: 'Echoué' },
            { value: 'Non Applicable', label: 'Non Applicable' },



        ]
        const checkTypeOptions = [
            { value: 'Manuel', label: 'Manuel' },
            { value: 'Automatique', label: 'Automatique' }

        ]

        const fetchValidationTask = async () => {
            try {
                const user = JwtService.getUser();
                console.log("user:", user);
                if (!user) return error("Utilisateur non connecté");
                const userId = user.userId.replace(/\/+$/, '').trim();
                if (!userId) return error("Utilisateur non connecté");
                const response = await ApiService.get(`/validationts?limit=0&userCreationId=${userId}`);
                const validationTaskData = response.data.data.data;
                validationtaskOptions.value = validationTaskData.map((validationtask) => ({
                    value: validationtask.id,
                    label: `${validationtask.status}`
                }))
            } catch (error) {
                //
            }
        }
        const isDateField = (key: string) => {
            return [
                "checked_at",
            ].includes(key);
        };

        const formatDate = (dateString: string) => {
            if (!dateString) return "";
            return dateString.split("T")[0];
        };

        interface FormDataType {
            title: string;
            check_code: string;
            description: string;
            comments: string;
            checked_at: string;

            check_type: { value: string; label: string } | null;
            result: { value: string; label: string } | null;
            severity: { value: string; label: string } | null;
            validationtasks: { value: number; label: string } | null;
        }

        const formData = reactive<FormDataType>({
            title: "",
            check_code: "",
            description: "",
            comments: "",
            checked_at: "",
            check_type: null,
            result: null,
            severity: null,
            validationtasks: null,
        });
        const getValidationCheck = async (id: string) => {
            try {
                const response = await ApiService.get(`/validationc/${id}`);
                const donnees = response.data.data;

                formData.title = donnees.title;
                formData.check_code = donnees.check_code;
                formData.description = donnees.description;
                formData.comments = donnees.comments;
                formData.checked_at = formatDate(donnees.checked_at);

                console.log('check_type reçu:', donnees.check_type);
                console.log('find result:', checkTypeOptions.find(opt => opt.value === donnees.check_type));
                // Multiselect statiques
                formData.check_type = checkTypeOptions.find(opt => opt.value === donnees.check_type) || null;
                formData.result = resultOptions.find(opt => opt.value === donnees.result) || null;
                formData.severity = severityOptions.find(opt => opt.value === donnees.severity) || null;

                // Validation Task (dynamique) - création manuelle car :object="true"
                formData.validationtasks = donnees.validationtasks ? {
                    value: donnees.validationtasks.id,
                    label: donnees.validationtasks.status
                } : null;

                await nextTick();

            } catch (err: any) {
                error(err.response?.data?.message || "Erreur lors du chargement");
            }
        };

        const EditValidationCheck = async () => {
            try {
                const payload = {
                    title: formData.title,
                    check_code: formData.check_code,
                    description: formData.description,
                    comments: formData.comments,
                    checked_at: formData.checked_at,
                    check_type: formData.check_type?.value,
                    result: formData.result?.value,
                    severity: formData.severity?.value,
                    validationtasks: formData.validationtasks?.value,  // envoie seulement l'ID
                };

                console.log("Payload FINAL :", payload);

                await ApiService.put(`/validationc/${checkId}`, payload);
                success("Modification réussie !");
                router.push("/listevalidationchecks");
            } catch (err: any) {
                error(err.response?.data?.message || "Échec de la modification");
            }
        };


        onMounted(async () => {
            await fetchValidationTask();
            await getValidationCheck(checkId as string)
        })

        return {
            EditValidationCheck,
            EditCheckSchema,
            validationtaskOptions,
            formData,
            severityOptions,
            resultOptions,
            checkTypeOptions
        };
    },
});
</script>